import { Race } from "./race";

export class Horse {
  birth: string;
  created_at: string;
  deleted_at: string;
  description: string;
  farm: Farm;
  farm_id: number;
  gender_id: number;
  history: Array<string>;
  id: number = null;
  instructor_id: number;
  microchip: any;
  microchip_number: number;
  name: string;
  updated_at: string;
  vetclinic_id: number;
  is_in_food_chain: boolean = true;
  in_training: boolean = false;
  is_active: boolean;
  has_active_vaccinations: boolean;
  external_reference: string;
  token?: string;
  hisa_id: string;
  is_eligible: boolean = false;
  eligible_forms: string = "";
  is_preTravel_forms_completed: boolean = false;
  races: Race[];
  declaration_status: string;
  treatment_status: string;
  submitted_notes_types: string[];
  submitted_treatment_types: string[];
  pre_travel_forms_status: string;
  pre_race_forms_status: string;
  next_to_submit: string;
  target_race_name: string;
  target_race_id: number;
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/core/classes/horse.ts